module.exports = __webpack_public_path__ + "img/pega_ceramicos_azulejos_piedras_naturales.f3322f2c.png";